module.exports = __webpack_public_path__ + "img/insta-13.f5952e0c.jpg";